import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ContactSales from "./BookDemo/ContactSales";
import Notification from "./BookDemo/Notification";
import ConfirmationModal from "./BookDemo/confirmationModal";
import axiosInstance from "../../axios";
import { useSelector } from "react-redux";
import EnterprisePayment from "../Enterprise/EnterprisePayment";
import { Loading } from "./Loading";
import arrow from "../../assets/images/Group 1322.jpg";
import ArrowFree from "../../assets/images/Group 1662.png";
import tick from "../../assets/images/Group 1674.jpg";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { useLocation } from "react-router";
import {
  featuresIcons,
  pricingContent,
  pricingFeatures,
  addonPlans,
  faqs,
} from "./Pricing/content";
import dots from "../Other/assets/dots.png";
import plus from "../Other/assets/more.png";
import PricingPlan from "./Pricing/PricingPlan";
import Accordian from "./Pricing/Accordian/Accordian";
import RequestDemo from "./Pricing/RequestDemo/RequestDemo";
import forwardArrow from "../../assets/images/right-arrow.png";

const PricingPage = () => {
  const { loggedIn, geoLocation } = useSelector(
    (state) => state.authentication
  );
  const [manageOverlay, setManageOverlay] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [manageNotification, setManageNotification] = useState(false);
  const [manageConfirmation, setManageConfirmation] = useState(false);
  const [manageContactSalesModal, setManageContactSalesModal] = useState(false);
  const [popUp, setPopUP] = useState(false);
  const [plan, setPlan] = useState();
  const [showDescription, setShowDescription] = useState(false);
  const [changedSelectedPlan, setChangedSelectedPlan] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);
  const [downGradeStatus, setDownGradeStatus] = useState(null);
  const [confirmationModalPopUp, setConfirmationModalPopUp] = useState({
    status: false,
    planType: null,
    value: null,
  });
  const [cardLabel, setCardLabel] = useState("");
  const [activeCard, setActiveCard] = useState(1);
  const location = useLocation();
  const { state } = location;
  const { t } = useTranslation();
  const [pricingList, setPricingList] = useState(pricingContent);

  const bookDemoHandler = () => {
    setManageOverlay(true);
  };

  const getCurrentsubscription = () => {
    if (loggedIn) {
      try {
        axiosInstance
          .get("/current-subscription")
          .then((res) => {
            setSubscriptionStatus(res?.data?.data);
          })
          .catch((res) => console.log(res));
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    getCurrentsubscription();
  }, [loggedIn]);

  useEffect(() => {
    // use [state?.comeFrom] for google analytics
    if (
      state !== null &&
      state !== undefined &&
      state?.comeFrom === undefined
    ) {
      handlePurchase(state);
    }
  }, [state]);

  const closeHandler = () => {
    setManageOverlay(false);
    setManageConfirmation(false);
  };

  const closeNotification = () => {
    setManageNotification(false);
  };

  const handleManageOverlay = (values) => {
    if (values) {
      setManageNotification(true);
    } else {
      setManageNotification(false);
    }
  };

  const planStatusChange = (existingPlanType) => {
    try {
      if (geoLocation?.country_code === "IN") {
        axiosInstance
          .get(`/razorpay-checkout-url?selectedPlan=${existingPlanType}`)
          .then((res) => {
            setDownGradeStatus(res.data.message);
            getCurrentsubscription();
          })
          .catch((res) => console.log(res));
      } else {
        axiosInstance
          .post("/charge-card-token", {
            selectedPlan: existingPlanType,
          })
          .then((res) => {
            setDownGradeStatus(res.data.message);
            getCurrentsubscription();
          })
          .catch((res) => console.log(res));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePurchase = (value) => {
    setStatusLoading(true);
    if (
      subscriptionStatus?.planInfo?.slug.toLowerCase() ===
      value.toLowerCase() &&
      subscriptionStatus?.subscribed?.isInTrial === 0 &&
      subscriptionStatus.subscribed.status === 0
    ) {
      setPopUP(true);
    } else if (
      loggedIn &&
      subscriptionStatus &&
      subscriptionStatus?.planInfo?.slug.toLowerCase() !== value.toLowerCase()
    ) {
      const planType = {
        lite: 1,
        pro: 2,
      };
      const existingPlan = planType[subscriptionStatus?.planInfo?.slug];
      const currentSelectPlan = planType[value];
      const planStatus =
        currentSelectPlan > existingPlan ? "upgrade" : "downgrade";

      if (planStatus == "upgrade") {
        setStatusLoading(false);
        setConfirmationModalPopUp({
          ...confirmationModalPopUp,
          status: !confirmationModalPopUp.status,
          planType: planStatus,
        });
        setChangedSelectedPlan(value);
      } else {
        setStatusLoading(false);
        setConfirmationModalPopUp({
          ...confirmationModalPopUp,
          status: !confirmationModalPopUp.status,
          planType: planStatus,
          value: value,
        });
      }
    } else {
      setStatusLoading(false);
      setManageConfirmation(true);
      setPlan(value);
    }
  };

  const handleContactSales = (value) => {
    setManageContactSalesModal(value);
  };

  useEffect(() => {
    if (manageContactSalesModal) {
      setManageOverlay(true);
    }
  }, [manageContactSalesModal]);

  const currentSubscriptionplan = (plan) => {
    if (
      subscriptionStatus?.planInfo?.name.toLowerCase() === plan.toLowerCase() &&
      subscriptionStatus?.subscribed?.status === 0
    ) {
      return "Purchase";
    } else if (
      subscriptionStatus?.planInfo?.name.toLowerCase() === plan.toLowerCase() &&
      subscriptionStatus?.subscribed?.status === 1
    ) {
      return "Subscribed plan";
    } else return "";
  };

  const closePaymentHandler = () => {
    setStatusLoading(!statusLoading);
    setDownGradeStatus(null);
  };

  const paymentConfirmation = () => {
    if (confirmationModalPopUp.planType === "downgrade") {
      planStatusChange(confirmationModalPopUp?.value);
      setStatusLoading(true);
      setConfirmationModalPopUp((state) => !state);
    } else {
      setStatusLoading(true);
      setPopUP(true);
      setConfirmationModalPopUp((state) => !state);
    }
  };

  const disableScroll = () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
    return setTimeout(() => {
      window.onscroll = function () { };
    }, 100);
  };

  const handleP_Cards = (key) => {
    setPricingList((state) =>
      state.map((pricing, index) =>
        index === key ? { ...pricing, isOpen: !pricing.isOpen } : pricing
      )
    );
  };

  return (
    <>
      {/* {manageOverlay ? (
        <BookDemo
          closeHandler={closeHandler}
          handleManageOverlay={handleManageOverlay}
        />
      ) : null} */}
      {manageConfirmation && (
        <ConfirmationModal
          closeHandler={closeHandler}
          bookDemoHandler={bookDemoHandler}
          planStatus={plan}
          setManageConfirmation={setManageConfirmation}
          comeFrom={state?.comeFrom}
        />
      )}
      {manageOverlay ? (
        <ContactSales
          closeHandler={closeHandler}
          handleManageOverlay={handleManageOverlay}
          handleContactSales={handleContactSales}
        />
      ) : null}
      {manageNotification ? (
        <Notification closeNotification={closeNotification} />
      ) : null}

      <div className="PricingPage">
        {popUp && (
          <EnterprisePayment
            setPopUP={setPopUP}
            setStatusLoading={setStatusLoading}
            changedSelectedPlan={changedSelectedPlan}
            setDownGradeStatus={setDownGradeStatus}
            countryCode={geoLocation?.country_code}
          />
        )}

        <div className="title-wrapper animate-from-bottom">
          <div className="inner-wrapper">
            <div className="content">
              <h1 className="heading">
                AFFORDABILITY <span>IN ONE PACKAGE</span>
              </h1>
              <p>
                Choose from one of our packages, or contact us to discuss a
                custom solution and pricing.
              </p>
            </div>
          </div>
          <div className="right-image-container">
            {/* <img src={dots} /> */}
          </div>
        </div>

        {/* Price toggle for Annual/Monthly */}
        {/* <div className="coming-soon hide">
          <div className="inner-wrapper">
            <label className="label">
              <div className="label-text">Annualy</div>
              <div className="toggle">
                <input
                  className="toggle-state"
                  type="checkbox"
                  name="check"
                  value="check"
                />
                <div className="indicator"></div>
              </div>
              <div className="label-text">Monthly</div>
            </label>
          </div>
        </div> */}
        {statusLoading && (
          <OverlayContainer>
            {downGradeStatus == null && (
              <div className="abolute-pricing-1">
                <Loading />
              </div>
            )}
            {downGradeStatus !== null && (
              <div className="quiz-eveny-0 paymentStatus abolute-pricing">
                <div className="quiz-popup" onClick={closePaymentHandler}>
                  <i className="icon check"></i>
                </div>
                <p>{downGradeStatus}</p>
              </div>
            )}
          </OverlayContainer>
        )}

        <div className="pricing-wrapper">
          <div className="pricing-inner-wrapper">
            {confirmationModalPopUp?.status && (
              <div className="quiz-eveny-0 paymentStatus abolute-pricing upGradeDownGradeStatus">
                <div
                  className="quiz-popup"
                  onClick={() =>
                    setConfirmationModalPopUp(!confirmationModalPopUp)
                  }
                >
                  <i className="icon check"></i>
                </div>
                <p>
                  Do you want to {confirmationModalPopUp?.planType} the plan
                </p>
                <div className="confirmationButton">
                  <button
                    className="btn confirmation"
                    onClick={paymentConfirmation}
                  >
                    Yes
                  </button>
                  <button
                    className="btn confirmationCancel"
                    onClick={() =>
                      setConfirmationModalPopUp(!confirmationModalPopUp)
                    }
                  >
                    No
                  </button>
                </div>
              </div>
            )}

            {pricingList.map((content, key) => (
              <div
                className="pricing-col"
                id={content.isOpen && `pricing_card${key + 1}`}
              >
                <div className="pricing-row">
                  <div className="pricing-header">
                    <img
                      className="pricing-arrow-img"
                      src={content.header.label === "Free" ? ArrowFree : arrow}
                      onClick={() => handleP_Cards(key)}
                    />
                    <div className="pricing-label">{content.header.label}</div>
                    <div className="pricing-title">{content.header.title}</div>
                    <div className="pricing-description">
                      {content.header.description}
                    </div>
                  </div>
                </div>
                <div className="pricing-row">
                  <div className="pricing-section">
                    <ul className="pricing-list">
                      {content.section.map((item) => (
                        <li className="pricing-item">
                          <div>
                            <span className="initial">{item.initial}</span>
                            <span>{item.rest}</span>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="pricing-row">
                  <div className="purchaseBtn">
                    {loggedIn && subscriptionStatus === null ? (
                      <Loading />
                    ) : (
                      <button
                        onClick={() =>
                          content.button.plan === "custom"
                            ? bookDemoHandler(true)
                            : handlePurchase(content.button.plan)
                        }
                        style={
                          currentSubscriptionplan(content.header.label) ===
                            "Subscribed plan"
                            ? {
                              color: "white",
                              background: "green",
                              border: "black",
                            }
                            : null
                        }
                        disabled={
                          currentSubscriptionplan(content.header.label) ===
                            "Subscribed plan"
                            ? true
                            : false
                        }
                      >
                        {currentSubscriptionplan(content.header.label)
                          ? currentSubscriptionplan(content.header.label)
                          : content.button.title}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* <div className="pricing-points-wrapper">
            <div className="inner-wrapper">
              <div className="plus">+</div>
              <div className="pricingTitle">
                {t("pricing.All our plans include")}
              </div>

              <ul className="pricing-list">
                <li>{t("pricing.unlmtCourses")}</li>
                <li>{t("pricing.Web conferencing")}</li>
                <li>{t("pricing.Webinar recording")}</li>
                <li>{t("pricing.File sharing")}</li>
                <li>{t("pricing.Visual scheduling")}</li>
                <li>{t("pricing.Community forum")}</li>
                <li>{t("pricing.Reporting")}</li>
                <li>{t("pricing.Analytics dashboard")}</li>
                <li>{t("pricing.Concurrent sessions")}</li>
                <li>{t("pricing.Secure SSL certification")}</li>
                <li>{t("pricing.Automated backup & restore")}</li>
                <li>{t("pricing.Customer support")}</li>
              </ul>
            </div>
          </div> */}
          <div className="pricing-features-section">
            <div className="icon-container">
              <img src={plus} />
            </div>
            <div className="inner-wrapper">
              <div className="title">
                ALL OUR PLANS INCLUDE <span>THE FOLLOWING FOR FREE</span>
              </div>
              <div className="features-container">
                {pricingFeatures.map((feature, index) => (
                  <div className="feature">
                    <div className="feature-image">
                      <span className="feature-tooltip">{feature.tootip}</span>
                      <img src={featuresIcons[index]} />
                    </div>
                    <div className="feature-tick-image">
                      <img src={tick} />
                    </div>
                    <div className="description">{feature.description}</div>
                  </div>
                ))}
              </div>
            </div>
            <RequestDemo />
          </div>

          <div className="feature-section-add-ons">
            <div className="inner-wrapper">
              <div className="header">
                <div className="title">
                  OPTIONAL PLAN <span>ADD-ONS</span>
                </div>
                <div className="description">
                  You must have at least one Licensed user to purchase these{" "}
                  <span>Add-on plans.</span>
                </div>
              </div>
              <div className="add-ons">
                <div id="1" className="pricing-col">
                  <div className="pricing-row">
                    <span>LANGUISITY</span>
                    <div className="sub-title">Coming Soon</div>
                  </div>
                  <div className="pricing-row">
                    Languisity is the seamless communications tool instructors
                    and learners offering real time translations in a webinar
                    setting.
                  </div>
                  <div className="pricing-row">
                    <PricingPlan
                      plans={addonPlans.languisity}
                      buttonText="Know More"
                    />
                  </div>
                </div>
                <div id="2" className="pricing-col">
                  <div className="pricing-row">
                    <span>SUPER ADMIN</span>
                    <div className="sub-title">Coming Soon</div>
                  </div>
                  <div className="pricing-row">
                    A Super Administrator is a user who has complete access to
                    all objects, folders, role templates, and groups in the
                    system.
                  </div>
                  <div className="pricing-row">
                    <PricingPlan
                      plans={addonPlans.admin}
                      buttonText="Notify Me"
                    />
                  </div>
                </div>
              </div>
              <div className="pricing-arrow-div">
                <a href={`#${activeCard}`} onClick={disableScroll}>
                  <img
                    onClick={() => setActiveCard(1)}
                    className={
                      activeCard === 1
                        ? "pricing-backward-arrow-disabled"
                        : "pricing-backward-arrow"
                    }
                    src={forwardArrow}
                  />
                </a>
                <a href={`#${activeCard}`} onClick={disableScroll}>
                  <img
                    onClick={() => setActiveCard(2)}
                    className={
                      activeCard === 2
                        ? "pricing-forward-arrow-disabled"
                        : "pricing-forward-arrow"
                    }
                    src={forwardArrow}
                  />
                </a>
              </div>
              <div className="faqs-container">
                <div className="header">
                  FREQUENTLY ASKED <span>QUESTIONS</span>
                </div>
                <div className="faqs">
                  {faqs.map(({ question, answer }) => (
                    <Accordian title={question}>{answer}</Accordian>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="pricing-footer">
            <div className="inner-wrapper">
              <div className="footer-title">
                READY TO <span>GET STARTED?</span>
              </div>
              <div className="purchaseBtn">
                <button onClick={() => handlePurchase("free")}>
                  SIGN UP, IT’S FREE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingPage;
